export type LocationShareScope = 'room' | 'drawer' | 'case';

/** ゲスト共有リンクを発行する対象（保管庫必須。未割当ルームは対象外） */
export type LocationShareTarget =
  | { scope: 'room'; storageRoomId: number }
  | { scope: 'drawer'; storageRoomId: number; drawerNumber: number | null }
  | {
      scope: 'case';
      storageRoomId: number;
      drawerNumber: number | null;
      caseName: string | null;
    };

export function locationShareTargetKey(target: LocationShareTarget): string {
  if (target.scope === 'room') return `room:${target.storageRoomId}`;
  if (target.scope === 'drawer') {
    return `drawer:${target.storageRoomId}:${target.drawerNumber ?? ''}`;
  }
  return `case:${target.storageRoomId}:${target.drawerNumber ?? ''}:${target.caseName ?? ''}`;
}

export function caseCellToLocationShareTarget(cell: {
  storageRoomId: number | null;
  drawerNumber: number | null;
  caseName: string | null;
}): LocationShareTarget | null {
  if (cell.storageRoomId == null) return null;
  return {
    scope: 'case',
    storageRoomId: cell.storageRoomId,
    drawerNumber: cell.drawerNumber,
    caseName: cell.caseName,
  };
}
